import { Routes } from '@angular/router';
import { MainContainerComponent } from './components/main-container/main-container.component';
import { authGuard } from './guards/auth.guard';
import { noNeedLoginGuard } from './guards/no-need-login.guard';
import { MenuViewEnum } from './models/enums/menu-view-enum';
import { MenuItem } from './models/menu-item';
import { AvailableSoonComponent } from './shared/components/available-soon/available-soon.component';
import { NoPermissionComponent } from './shared/components/no-permission/no-permission.component';

export const routes: Routes = [
  {
    path: '',
    component: MainContainerComponent,
    children: [
      {
        path: 'dashboard',
        data: {
          type: 'dashboard',
          permissions: [MenuViewEnum.DashboardView],
        },
        canActivate: [authGuard],
        loadChildren: () => import('./routes/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },

      {
        path: 'annual-investment-plans',
        data: {
          type: 'policies',
          permissions: [MenuViewEnum.InvestmentPlanView],
        },
        loadChildren: () =>
          import('./routes/annual-investment-plans/annual-investment-plans.module').then((m) => m.AnnualInvestmentPlansModule),
      },

      {
        path: 'investment-plans',
        data: {
          type: 'policies',
          permissions: [MenuViewEnum.InvestmentPlanView],
        },
        loadChildren: () => import('./routes/investment-plans/investment-plans.module').then((m) => m.InvestmentPlansModule),
      },
      {
        path: 'investment-portfolios',
        data: {
          type: 'investment-portfolios',
          permissions: [MenuViewEnum.InvestmentPortfolioView],
        },
        loadChildren: () => import('./routes/investment-portfolios/investment-portfolios.module').then((m) => m.InvestmentPortfoliosModule),
      },
      {
        path: 'investment-funds/investment-fund-management',
        data: {
          type: 'investment-funds',
          isSub: true,
          permissions: [MenuViewEnum.InvestmentFundView],
        },
        loadChildren: () =>
          import('./routes/manage-investment-fund/manage-investment-fund.module').then((m) => m.ManageInvestmentFundModule),
      },
      {
        path: 'investment-funds/investment-fund-statuses',
        data: {
          type: 'investment-funds',
          isSub: true,
          permissions: [MenuViewEnum.InvestmentFundView],
        },
        // component: AvailableSoonComponent,
        loadChildren: () =>
          import('./routes/investment-fund-statuses/investment-fund-statuses.module').then((m) => m.InvestmentFundStatusesModule),
      },
      {
        path: 'investment-requests/fixed-deposits',
        data: {
          type: 'investment-requests',
          isSub: true,
          permissions: [MenuViewEnum.FixedInvestmentRequestView],
        },
        loadChildren: () => import('./routes/fixed-deposits/fixed-deposits.module').then((m) => m.FixedDepositsModule),
      },
      {
        path: 'bank-data/liability-management',
        data: {
          isSub: true,
          type: 'bank-data',
          permissions: [MenuViewEnum.BankStatGroupView],
        },
        loadChildren: () =>
          import('./routes/asset-and-liability-management/asset-and-liability-management.module').then(
            (m) => m.AssetAndLiabilityManagementModule
          ),
      },
      {
        path: 'bank-data/compare-growth-rates',
        data: {
          type: 'bank-data',
          isSub: true,
          permissions: [MenuViewEnum.RiskComparisonView],
        },
        loadChildren: () => import('./routes/compare-growth-rates/compare-growth-rates.module').then((m) => m.CompareGrowthRatesModule),
      },
      {
        path: 'investment-requests/government-bonds',
        data: {
          type: 'investment-requests',
          isSub: true,
        },
        component: AvailableSoonComponent,
      },
      {
        path: 'investment-requests/corporate-bonds',
        data: {
          type: 'investment-requests',
          isSub: true,
        },
        component: AvailableSoonComponent,
      },
      // {
      //   path: 'payment-requests/fixed-deposits',
      //   data: {
      //     type: 'payment-requests',
      //     isSub: true,
      //   },
      //   component: AvailableSoonComponent,
      // },
      // {
      //   path: 'payment-requests/government-bonds',
      //   data: {
      //     type: 'payment-requests',
      //     isSub: true,
      //   },
      //   component: AvailableSoonComponent,
      // },
      // {
      //   path: 'payment-requests/corporate-bonds',
      //   data: {
      //     type: 'payment-requests',
      //     isSub: true,
      //   },
      //   component: AvailableSoonComponent,
      // },
      {
        path: 'investment-management/fixed-deposits',
        data: {
          type: 'investment-management',
          isSub: true,
          permissions: [MenuViewEnum.FixedInvestmentView],
        },
        loadChildren: () =>
          import('./routes/fixed-deposit-request-management/fixed-deposit-request-management.module').then(
            (m) => m.FixedDepositRequestManagementModule
          ),
      },
      {
        path: 'investment-management/government-bonds',
        data: {
          type: 'investment-management',
          isSub: true,
        },
        component: AvailableSoonComponent,
      },
      {
        path: 'investment-management/corporate-bonds',
        data: {
          type: 'investment-management',
          isSub: true,
        },
        component: AvailableSoonComponent,
      },
      {
        path: 'accounting/journals',
        data: {
          type: 'accounting',
          isSub: true,
          permissions: [MenuViewEnum.JournalReportView],
        },
        loadChildren: () => import('./routes/journals/journals.module').then((m) => m.JournalsModule),
      },
      {
        path: 'accounting/general-ledgers',
        data: {
          type: 'accounting',
          isSub: true,
          permissions: [MenuViewEnum.GeneralLedgerReportView],
        },
        loadChildren: () => import('./routes/general-ledgers/general-ledgers.module').then((m) => m.GeneralLedgersModule),
      },
      {
        path: 'accounting/account-charts',
        data: {
          type: 'accounting',
          isSub: true,
          permissions: [MenuViewEnum.ChartOfAccountView],
        },
        loadChildren: () => import('./routes/chart-of-accounts/chart-of-accounts.module').then((m) => m.ChartOfAccountsModule),
      },

      {
        path: 'reports/payment-reports',
        data: {
          type: 'reports',
          isSub: true,
          permissions: [MenuViewEnum.ChartOfAccountView],
        },
        loadChildren: () => import('./routes/payment-reports/payment-reports.module').then((m) => m.PaymentReportsModule),
      },
      // {
      //   path: 'accounting/financial-reports',
      //   data: {
      //     type: 'accounting',
      //     isSub: true,
      //     permissions: [MenuViewEnum.ChartOfAccountView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/accounting-reports/accounting-reports.module').then(
      //       (m) => m.AccountingReportsModule,
      //     ),
      // },
      {
        path: 'reports/net-asset-report',
        data: {
          type: 'reports',
          isSub: true,
          permissions: [MenuViewEnum.NetAssetReportView],
        },
        loadChildren: () => import('./routes/net-asset-report/net-asset-report.module').then((m) => m.NetAssetReportModule),
      },
      {
        path: 'reports/accrual-report',
        data: {
          type: 'reports',
          isSub: true,
          permissions: [MenuViewEnum.AccrualReportView],
        },
        loadChildren: () => import('./routes/accrual-report/accrual-report.module').then((m) => m.AccrualReportModule),
      },
      {
        path: 'reports/investment-report',
        data: {
          type: 'reports',
          isSub: true,
          permissions: [MenuViewEnum.InvestmentReportView],
        },
        loadChildren: () => import('./routes/investment-reports/investment-reports.module').then((m) => m.InvestmentReportsModule),
      },
      {
        path: 'reports/risk-evaluation-report',
        data: {
          type: 'reports',
          isSub: true,
          permissions: [MenuViewEnum.RiskEvaluationReportView],
        },
        loadChildren: () =>
          import('./routes/risk-evaluation-report/risk-evaluation-report.module').then((m) => m.RiskEvaluationReportModule),
      },
      {
        path: 'reports/risk-evaluation-investment-request-report',
        data: {
          type: 'reports',
          isSub: true,
          permissions: [MenuViewEnum.RiskEvaluationReportView],
        },
        loadChildren: () =>
          import('./routes/risk-evaluation-investment-request-report/risk-evaluation-investment-request-report.module').then(
            (m) => m.RiskEvaluationInvestmentRequestReportModule
          ),
      },

      // {
      //   path: 'reports/income-statement',
      //   data: {
      //     type: 'reports',
      //     isSub: true,
      //   },
      //   component: AvailableSoonComponent,
      // },
      // {
      //   path: 'reports/capital-reports',
      //   data: {
      //     type: 'reports',
      //     isSub: true,
      //     permissions: [MenuViewEnum.FinancialReportView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/capital-reports/capital-reports.module').then(
      //       (m) => m.CapitalReportsModule,
      //     ),
      // },
      // {
      //   path: 'reports/cashflow-reports',
      //   data: {
      //     type: 'reports',
      //     isSub: true,
      //     permissions: [MenuViewEnum.CashFlowReportView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/cashflow-reports/cashflow-reports.module').then(
      //       (m) => m.CashflowReportsModule,
      //     ),
      // },
      // {
      //   path: 'reports/profit-and-loss',
      //   data: {
      //     type: 'reports',
      //     isSub: true,
      //     permissions: [MenuViewEnum.IncomeExpenseReportView],
      //   },
      //   loadChildren: () =>
      //     import(
      //       './routes/profit-and-loss-report/profit-and-loss-report.module'
      //     ).then((m) => m.ProfitAndLossReportModule),
      // },
      // {
      //   path: 'reports/financial-statuses',
      //   data: {
      //     type: 'reports',
      //     isSub: true,
      //     permissions: [MenuViewEnum.FinancialReportView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/financial-statuses/financial-statuses.module').then(
      //       (m) => m.FinancialStatusesModule,
      //     ),
      // },
      // {
      //   path: 'reports/financial-highlight',
      //   data: {
      //     type: 'reports',
      //     isSub: true,
      //     permissions: [MenuViewEnum.FinancialReportView],
      //   },
      //   loadChildren: () =>
      //     import(
      //       './routes/financial-highlight/financial-highlight.module'
      //     ).then((m) => m.FinancialHighlightModule),
      // },
      {
        path: 'audit/audit-reports',
        data: {
          type: 'audit',
          isSub: true,
          permissions: [MenuViewEnum.AuditReportView],
        },
        loadChildren: () => import('./routes/audit-reports/audit-reports.module').then((m) => m.AuditReportsModule),
      },
      {
        path: 'audit/audit-rules',
        data: {
          type: 'audit',
          isSub: true,
          permissions: [MenuViewEnum.AuditRuleView],
        },
        loadChildren: () => import('./routes/audit-rules/audit-rules.module').then((m) => m.AuditRulesModule),
      },
      // {
      //   path: 'audit/compliance-reports',
      //   data: {
      //     type: 'audit',
      //     isSub: true,
      //     permissions: [MenuViewEnum.AuditReportView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/compliance-reports/compliance-reports.module').then(
      //       (m) => m.ComplianceReportsModule,
      //     ),
      // },
      // {
      //   path: 'audit/file-management',
      //   data: {
      //     type: 'audit',
      //     isSub: true,
      //     permissions: [MenuViewEnum.AuditDocumentView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/file-management/file-management.module').then(
      //       (m) => m.FileManagementModule,
      //     ),
      // },
      // {
      //   path: 'audit/compliance-reports',
      //   data: {
      //     type: 'audit',
      //     isSub: true,
      //     permissions: [MenuViewEnum.AuditReportView],
      //   },
      //   loadChildren: () =>
      //     import('./routes/compliance-reports/compliance-reports.module').then(
      //       (m) => m.ComplianceReportsModule,
      //     ),
      // },
      {
        path: 'audit/logs',
        data: {
          type: 'audit',
          isSub: true,
          permissions: [MenuViewEnum.AuditLogView],
        },
        loadChildren: () => import('./routes/document-logs/document-logs.module').then((m) => m.DocumentLogsModule),
      },
      {
        path: 'settings/banks',
        data: {
          type: 'settings',
          isSub: true,
          permissions: [MenuViewEnum.BankView],
        },
        loadChildren: () => import('./routes/banks/banks.module').then((m) => m.BanksModule),
      },
      {
        path: 'settings/asset-types',
        data: {
          type: 'settings',
          isSub: true,
          permissions: [MenuViewEnum.AssetView],
        },
        loadChildren: () => import('./routes/asset-types/asset-types.module').then((m) => m.AssetTypesModule),
      },
      {
        path: 'settings/segments',
        data: {
          type: 'settings',
          isSub: true,
          permissions: [MenuViewEnum.SegmentView],
        },
        loadChildren: () => import('./routes/segment/segment.module').then((m) => m.SegmentModule),
      },
      {
        path: 'settings/workflows',
        data: {
          type: 'settings',
          isSub: true,
          permissions: [MenuViewEnum.WorkflowView],
        },
        loadChildren: () => import('./routes/workflows/workflows.module').then((m) => m.WorkflowsModule),
      },
      {
        path: 'settings/users',
        data: {
          type: 'settings',
          isSub: true,
          permissions: [MenuViewEnum.UserAccountView],
        },
        loadChildren: () => import('./routes/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'settings/roles-and-permissions',
        data: {
          type: 'settings',
          isSub: true,
          permissions: [MenuViewEnum.RoleView],
        },
        loadChildren: () => import('./routes/roles/roles.module').then((m) => m.RolesModule),
      },
      {
        path: 'about-us',
        data: {
          type: 'about-us',
        },
        component: AvailableSoonComponent,
      },
      {
        path: 'no-permission',
        component: NoPermissionComponent,
      },
    ],
  },
  {
    path: 'auth/callback',
    loadChildren: () => import('./routes/nssf-callback/nssf-callback.module').then((m) => m.NssfCallbackModule),
  },
  {
    path: 'login',
    canActivate: [noNeedLoginGuard],
    loadChildren: () => import('./routes/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
export const MENUITEMS: Array<MenuItem> = routes[0].children!.map((routeItem) => {
  return {
    route: routeItem.path,
    type: routeItem.data?.type,
    permissions: routeItem.data?.permissions as MenuViewEnum[],
    title: routeItem.path.split('/').pop(),
    icon: routeItem.data?.icon,
    iconType: routeItem.data?.iconType,
    isSub: routeItem.data?.isSub,
  } as MenuItem;
});
